import React, { Component } from 'react'
const styles = require('./index.module.less')

export default class TabTitle extends Component {
    static defaultProps = {
      index: 0,
      tabTitle: {},
      moduleId: '',
      changeActiveKey: function () {}
    }

    shouldComponentUpdate (nextProps, nextState) {
      return false
    }

    /**
     * 鼠标hover切换标签
     * @param {Object} params
     */
    handleMouseEnter (params) {
      const activeKey = ((params.index) + '')
      this.props.changeActiveKey({ index: activeKey, link: params.link })
    }

    render () {
      const tabTitle = this.props.tabTitle
      const title = tabTitle.name || ''
      let html = ''
      if (tabTitle.link) {
        html = (
          <a
            data-spm={tabTitle.spm}
            target='_blank'
            href={tabTitle.link}
            className={styles.tab_title}>
            {title}
            {
              tabTitle.summary
                ? <span className={styles.tab_sub_title}>{tabTitle.summary}</span>
                : ''
            }
          </a>)
      } else {
        html = (
          <div className={styles.tab_title}>
            {title}
            { tabTitle.summary ? <span className={styles.tab_sub_title}>{tabTitle.summary}</span> : ''}
          </div>)
      }
      return html
    }
}
